module.exports = __webpack_public_path__ + "static/media/undraw_on_the_way_ldaq.076e8710.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Landing/undraw_on_the_way_ldaq.svg
// module id = 2858
// module chunks = 0